import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BankService {

  constructor(private http: HttpClient) { }

  updateById(id: string, data: any) {
    return this.http.put(environment.apiUrl + `admin/banks/${id}`, data)
      .pipe(map((result) => result));
  }
}
